import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AssetUploadId = Brand<number, 'AssetUploadId'>;
export const AssetUploadId = createBranded<AssetUploadId>();
